// extracted by mini-css-extract-plugin
export default {"container":"buy-tickets_container__1V2ea","disabled":"buy-tickets_disabled__55u6X"};